export enum AccessCode {
    ECQ = 'ECQ',
    OEM = 'OEM',
    MYH = 'MYH',
    ECLAIR = 'ECLAIR',
    SDI = 'SDI',
}
